import React, { useState } from "react";
import { Button, Row } from "reactstrap";
import { CounterDeviceWidget } from "../Components";
import { translate } from "../../utils/i18n";
import { Link } from "react-router-dom";

const CountersGroupContainer = props => {
  const [isCollapsed, setisCollapsed] = useState(false);

  return (
    <div className={isCollapsed ? "px-0 my-4 " : "px-0 my-4 shadow-sm"}>
      {props.group.devices.length > 0 ? (
        <React.Fragment>
          <div
            className={
              isCollapsed
                ? "shadow-sm organization-wrapper py-3 d-flex justify-content-between "
                : "organization-wrapper py-3 d-flex justify-content-between "
            }
          >
            <p className="pl-3 h3 pointer">
              <Link to={`organizations/${props.group.group_org_id}/groups`}> {props.group.name}</Link>{" "}
              <Link to={`organizations/${props.group.group_org_id}/devices`} className="font-weight-lighter lead">
                ({props.group.devices.length}) {props.group.devices.length === 1 ? translate("dashboard.device") : translate("dashboard.devices")}
              </Link>
            </p>
            <Button
              color="link"
              className="pull-left  pointer"
              onClick={() => {
                setisCollapsed(!isCollapsed);
              }}
            >
              <i className={isCollapsed ? "fa fa-plus mr-1 lead" : "fa fa-minus mr-1 lead"} />
            </Button>
          </div>

          {!isCollapsed &&
            (props.group.devices.length && (
              <div className="mx-2">
                <Row>
                  {props.group.devices.map(device => (
                    <CounterDeviceWidget deviceData={device} key={device._id} DeviceGroup={props.group} />
                  ))}
                </Row>
              </div>
            ))}
        </React.Fragment>
      ) : (
          <React.Fragment>
            <div className="shadow-sm organization-wrapper py-3 d-flex justify-content-start ">
              <p className="pl-3 h3 pointer">
                <Link to={`organizations/${props.group.group_org_id}/groups`}>{props.group.name}</Link>{" "}
                <Link to={`organizations/${props.group.group_org_id}/devices`} className="font-weight-lighter lead text-danger">
                  ({props.group.devices.length}) {translate("dashboard.device")}
                </Link>
              </p>
            </div>
          </React.Fragment>
        )}
    </div>
  );
};

export default CountersGroupContainer;
